import makeStyles from '@material-ui/styles/makeStyles';

export default makeStyles(theme => ({
  formContainer: {
    marginTop: theme.spacing(2)
  },
  form: {
    padding: theme.spacing(2)
  },
  saveButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}));
